<template>
  <b-row
    :ref="`card__part${partOrder}-task-list`"
    :class="`card__part${partOrder}-task-list`"
    class="w-100 mx-auto"
  >
    <b-col class="p-0">
      <base-card-indicator
        v-if="addable || (!addable && posts.length)"
        variant="info"
        :class="`card__part${partOrder}-title`"
      >
        <div class="d-flex align-items-center justify-content-between">
          <h5
            :id="`card__part${partOrder}-task-list-title`"
            class="font-weight-bold text__part-title mb-0 observable"
          >
            Part {{ partOrder }} : {{ partName }}
          </h5>

          <router-link v-if="addable && !hasUserEnrolled" :to="createPostEvaluationAssessmentPage">
            <b-button
              :ref="`button__add-task-part-${partOrder}`"
              class="button__add-task"
              variant="outline-primary"
            >
              Add task
            </b-button>
          </router-link>

          <b-button
            v-if="collapse"
            class="p-0"
            :aria-expanded="visibleRecommendation ? 'true' : 'false'"
            :aria-controls="`card__part${partOrder}`"
            variant="link"
            style="width: auto; border: none"
            @click="visibleRecommendation = !visibleRecommendation"
            >{{ visibleRecommendation ? 'Hide' : 'Show' }}</b-button
          >
          <span v-if="allowAssess && !readonly">
            <b-badge
              :variant="allAssessmentEvaluationsIsDone ? 'neutral-success' : 'neutral-danger'"
              pill
              :class="allAssessmentEvaluationsIsDone ? 'text-sucess' : 'text-danger'"
            >
              {{ allAssessmentEvaluationsIsDone ? 'Completed' : 'Not Completed' }}</b-badge
            >
          </span>
          <span v-if="submittable && visibleStatusSubmittable">
            <b-badge
              :variant="allPostResponsesCompleted ? 'neutral-success' : 'neutral-danger'"
              pill
              :class="allPostResponsesCompleted ? 'text-sucess' : 'text-danger'"
            >
              {{ allPostResponsesCompleted ? 'Completed' : 'Not Completed' }}</b-badge
            >
          </span>
        </div>
      </base-card-indicator>

      <b-collapse :id="`card__part${partOrder}`" v-model="visibleRecommendation" class="p-0">
        <learning-unit-part-description
          v-if="havePartDescription && (editable || (!editable && posts.length))"
          class="w-100"
          :learning-unit="learningUnit"
          :part="part"
          :editable="editable"
        ></learning-unit-part-description>

        <b-row v-if="posts.length">
          <b-col cols="12">
            <post-evaluation-assessment-card
              v-for="(post, postIndex) in posts"
              :id="`card__part${partOrder}-task${postIndex + 1}`"
              ref="card__part-post-list"
              :key="`card__part${partOrder}-task${postIndex + 1}`"
              :class="`mb-3 card__part${partOrder}-task${postIndex + 1}`"
              :part="part"
              :post="post"
              :order="postIndex + 1"
              :editable="editable"
              :submittable="submittable"
              :assessable="assessable"
              :disabled="disabled"
              :evidence-submission="evidenceSubmission"
              class="mt-3 observable"
              :mode="mode"
              :evidence-submitting="evidenceSubmitting"
              :readonly="readonly"
              :allow-assess="allowAssess"
              :hide-comment="hideComment"
              :hide-delete="hasUserEnrolled"
              :is-denied-page="isDeniedPage"
              :assessable-title="assessableTitle"
            >
            </post-evaluation-assessment-card>
          </b-col>
        </b-row>

        <b-row v-else-if="editable" class="my-4">
          <b-col cols="12" class="card__no-task">
            <p class="text-black-50">No task</p>
          </b-col>
        </b-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import EvidenceSubmission from '@/models/EvidenceSubmission';
import LearningUnit from '@/models/LearningUnit';
import Post from '@/models/Post';
import PostResponse from '@/models/PostResponse';
import BaseCardIndicator from '@/components/base-components/BaseCardIndicator';
import PostEvaluationAssessmentCard from '@/components/Post/PostEvaluationAssessmentCard';
import LearningUnitPartDescription from '@/components/LearningUnit/LearningUnitPartDescription';
import { isBoolean } from 'lodash';
import { useValidator } from '@/composables/useValidator';
const { isNotBlank } = useValidator();

export default {
  components: {
    BaseCardIndicator,
    PostEvaluationAssessmentCard,
    LearningUnitPartDescription
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },
    part: {
      type: String,
      default: '',
      requried: true
    },
    postIds: {
      type: Array,
      default: () => []
    },
    addable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    submittable: {
      type: Boolean,
      default: false
    },
    assessable: {
      type: Boolean,
      default: false
    },
    evidenceSubmitting: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    evidenceSubmission: {
      type: EvidenceSubmission,
      default: () => null
    },
    mode: {
      type: String,
      default: ''
    },

    readonly: {
      type: [Number, Boolean],
      default: false
    },

    allowAssess: {
      type: Boolean,
      default: false
    },

    collapse: {
      type: Boolean,
      default: false
    },

    hideComment: {
      type: Boolean,
      default: false
    },

    hasUserEnrolled: {
      type: Boolean,
      default: false
    },
    visibleStatusSubmittable: {
      type: Boolean,
      default: false
    },

    isDeniedPage: {
      type: Boolean,
      default: false
    },
    assessableTitle: {
      type: String,
      default: 'Comment'
    }
  },

  data() {
    return {
      visibleRecommendation: true
    };
  },

  computed: {
    createPostEvaluationAssessmentPage() {
      return {
        name: 'learning-unit/evaluation-assessment/create',
        params: {
          learningUnitId: this.learningUnit.id,
          part: this.part.toLowerCase()
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    },

    havePartDescription() {
      const partDescriptionMetaData = LearningUnit.PART_DESCRIPTION_META_DATA[this.part];

      return partDescriptionMetaData && partDescriptionMetaData === true;
    },

    partOrder() {
      return Post.PART_ORDER[this.part];
    },

    partName() {
      return Post.PART[this.part];
    },

    posts() {
      const { postIds = [] } = this;

      return Post.query().where('part', this.part).whereIdIn(postIds).get();
    },

    allAssessmentEvaluationsIsDone() {
      const { postIds = [] } = this;
      const postResponses = postIds.map((postId) => {
        return PostResponse.query()
          .where('evidence_submission_id', this.evidenceSubmission.id)
          .where('assessment_evaluation_id', (value) => value !== null)
          .where('post_id', postId)
          .with('assessment_evaluation')
          .first();
      });

      const hasAllCriteriaEditedDone =
        postResponses && postResponses.length
          ? postResponses.every(({ is_editing = false }) => is_editing === false)
          : false;

      const hasAllCriteriaDone =
        postResponses && postResponses.length
          ? postResponses.every((post_response) => {
              return isBoolean(post_response.assessment_evaluation.pass);
            })
          : false;

      return hasAllCriteriaEditedDone && hasAllCriteriaDone;
    },

    allPostResponsesCompleted() {
      const { postIds = [] } = this;

      const postResponse = postIds.map((postId) => {
        return PostResponse.query()
          .where('evidence_submission_id', this.evidenceSubmission?.id)
          .where('post_id', postId)
          .first();
      });

      return postResponse && postResponse.length
        ? postResponse.every((post_response) => {
            return (
              post_response &&
              post_response.description &&
              isNotBlank(post_response.description) &&
              post_response.save_message === 'Saved'
            );
          })
        : false;
    }
  }
};
</script>

<style lang="scss">
.text-sucess {
  color: #1bc943 !important;
}
.text-danger {
  color: #f83245 !important;
}

.card__no-task {
  max-width: 910px;
  margin: auto;
}
</style>
